<template>
    <div>
        <Header/>
        <div class="s_banner">
            <img src="https://cdn.gda.top/image_after_2019_06/2862/sctajik-logo1.jpg"/>
        </div>
        <div class="wrapper">
           <div class="s_top s_top2">
            <div class="nei_nav font18 pd60">
             {{$t('current_page')}}
             <router-link :to="{ name: 'News' }">{{$t('news_center')}}</router-link>&nbsp;&nbsp;&gt;&nbsp;&nbsp;{{$t('article_details')}}
            </div>
            <div class="title pd60">
             {{$t('article_details')}}
            </div>
            <div class="tips pd60">
             <p></p>
            </div>
           </div>
           <div class="main">
            <div class="newsBox">
             <h2 class="title"> {{newDataDetail.title}} </h2>
             <h3 class="subtitle"><span id="authorSpan" style="display:none;">{{newDataDetail.category_name}}：</span><span>{{$t('date')}}：{{newDataDetail.create_time}}</span></h3>
             <div class="text" v-html="newDataDetail.content" style="font-size: !important;padding-left: 200px;">
             </div>
            </div>
           </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
    import Footer from "../components/Footer";
    import Header from "../components/Header";

    export default {
        components: {Header, Footer},
        data() {
            return {
                newDataDetail: []
            }
        },
        mounted() {
            //回到顶部
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            this.reloadData();
        },
        methods: {
            reloadData(){
              this.getUrl('/official_website/news/news_detail', {
                lang: this.currentLang,
                id: this.$route.params.id
              }).then((response) => {
                  if(response.data.code == 20000){
                    this.newDataDetail = response.data.data;
                  }
              });
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>
<style scoped>
    a:hover {
        text-decoration: underline;
        text-decoration-color: #3e6be3;
        cursor: pointer;
    }
    .font18 a:hover{
        text-decoration: none;
        cursor: pointer;
    }
</style>
